module.exports = __webpack_public_path__ + "static/img/offices-big-2.0bbaff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offices-big-2.png
// module id = nnAi
// module chunks = 1